<template>
  <svg
    width="27"
    height="25"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient :id="`paint0_linear_${uniqueId}`">
        <stop offset="0%" stop-color="#EF6549" />
        <stop offset="100%" stop-color="#B23066" />
      </linearGradient>
    </defs>
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        :fill="`url(#paint0_linear_${uniqueId})`"
        fill-rule="evenodd"
        d="M14,9.00421 C14.5523,9.00421 15,9.45192 15,10.00418 L15,13.00418 C15,14.10878 14.1046,15.00418 13,15.00418 L3,15.00418 C1.89543,15.00418 1,14.10878 1,13.00418 L1,10.00418 C1,9.45192 1.44772,9.00421 2,9.00421 C2.55228,9.00421 3,9.45192 3,10.00418 L3,13.00418 L13,13.00418 L13,10.00418 C13,9.45192 13.4477,9.00421 14,9.00421 Z M8,1.59 L11.7071,5.2971 C12.0976,5.68763 12.0976,6.32079 11.7071,6.71132 C11.3166,7.10184 10.6834,7.10184 10.2929,6.71132 L9,5.41842 L9,10.00418 C9,10.55648 8.55228,11.00418 8,11.00418 C7.44772,11.00418 7,10.55648 7,10.00418 L7,5.41842 L5.70711,6.71132 C5.31658,7.10184 4.68342,7.10184 4.29289,6.71132 C3.90237,6.32079 3.90237,5.68763 4.29289,5.2971 L8,1.59 Z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  data() {
    return {
      uniqueId: null
    }
  },
  mounted() {
    this.uniqueId = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
  }
}
</script>
